import api from 'api/client';
import ROUTES from 'routes';
import { pathFromRoute, upon } from 'utils';
import Route from '@ohmsd/utils/Route';
import { STATUS } from 'const/adsAccs';

export function fetchConvAdsAccs (appId, convId) {
  const path = pathFromRoute(ROUTES.API.CONVERSIONS_ADS_ACCOUNTS, { appId, convId });
  return api.get(path);
}

export function toggleConvAdsAccInstance ({ appId, convId }, adsAccInst) {
  const id = adsAccInst.adsAccountId;
  const method = adsAccInst.status === STATUS.ACTIVE ? 'unlink' : 'link';
  const path = pathFromRoute(ROUTES.API.CONVERSIONS_ADS_ACCOUNTS, { appId, convId, id });

  return api.post(`${ path }/${ method }`, adsAccInst);
}


export function fetchAudAdsAccs (appId, audId) {
  const path = pathFromRoute(ROUTES.API.AUDITORY_ADS_ACCOUNTS, { appId, audId });
  return api.get(path);
}

export function fetchAdsAccs () {
  // const path = (new Route(ROUTES.API.ADS_ACCOUNTS)).stringify({
  //   query: { appId, adverId },
  // });
  return api.get(ROUTES.API.ADS_ACCOUNTS);
}

export function getAdsAcc (appId, accId) {
  const path = pathFromRoute(ROUTES.API.ADS_ACCOUNTS, { appId, id: accId });

  return api.get(path);
}

export function createAdsAcc (adsAcc) {
  const path = pathFromRoute(ROUTES.API.ADS_ACCOUNTS);

  return api.post(path, adsAcc);
}

export function updateAdsAcc (adsAcc) {
  const { id } = adsAcc;
  const path = pathFromRoute(ROUTES.API.ADS_ACCOUNTS, { id });

  return api.put(path, adsAcc);
}

export function deleteAdsAcc ({ id }) {
  const path = pathFromRoute(ROUTES.API.ADS_ACCOUNTS, { id });

  return api.delete(path);
}

export function getOAuthLink (type) {
  const path = new Route(ROUTES.API.GOOGLE_REDIRECT, {
    params: { type },
    query: {
      callbackUrl: `${ window.location.origin }${ ROUTES.GOOGLE_OAUTH_CALLBACK }`,
    },
  });

  return api.get(path.toString());
}

export function googleCallback ({ state, code }) {
  //_DISALLOW
  // return Promise.resolve({ data: [{"name":"OHM Smalldata NL OHM Smalldata NL OHM Smalldata NL OHM Smalldata NL OHM Smalldata NL ","id":"9022825725","state":"accessible"}, {"name":"OHM Smalldata NL OHM NL ","id":"9022825325","state":"accessible"}]})
  return api.post(ROUTES.API.GOOGLE_CALLBACK, { state, code });
}

export function getChildAccs ({ state, parentId }) {
  //_DISALLOW
  // if (parentId === '1234')
  //   return Promise.resolve({ data: []})
  // return upon(1e3, { resolve: { data: [{"name":"RO First AccountRO First AccountRO First AccountRO First AccountRO First Account","id":"1234","state":"accessible"}]} })
  // return upon(1e3, { resolve: { data: [{"name":"RO First AccountRO First AccountRO First AccountRO First AccountRO First Account","id":"1234","state":"accessible"}]} })
  return api.get(ROUTES.API.GOOGLE_CHILD_ACCS, {
    query: { state, parentId },
  });
}

export function googleCreateAcc (adsAcc) {
  return api.post(ROUTES.API.GOOGLE_CREATE_ACC, adsAcc);
}

export function toggleAudAdsAccLink ({ audId, appId }, adsAccInst, useSystem) {
  const id = adsAccInst.adsAccountId;
  const method = adsAccInst.status === STATUS.ACTIVE ? 'unlink' : 'link';

  return api.post(
    `${ ROUTES.API.AUDITORY_ADS_ACCOUNTS }/${ method }`,
    adsAccInst,
    {
      query: { appId, system: useSystem || undefined },
      params: { audId, id },
    },
  );
}

